import { render, staticRenderFns } from "./ChipNumbers.vue?vue&type=template&id=70bb9a93&scoped=true"
import script from "./ChipNumbers.vue?vue&type=script&lang=js"
export * from "./ChipNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb9a93",
  null
  
)

export default component.exports